export const saveBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
};

export const filenameFromDisposition = (header, fallback) => {
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(header || "");
  if (!match) return fallback;
  try {
    return decodeURIComponent(match[1]);
  } catch (e) {
    return match[1];
  }
};

// Com responseType "blob" o corpo de erro (JSON) também chega como Blob.
export const blobToJson = (blob) =>
  new Promise((resolve) => {
    if (!blob || typeof blob.size !== "number") {
      resolve(null);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      try {
        resolve(JSON.parse(reader.result));
      } catch (e) {
        resolve(null);
      }
    };
    reader.onerror = () => resolve(null);
    reader.readAsText(blob);
  });

const csvCell = (value) => {
  let text = value == null ? "" : String(value);
  if (/^[=+\-@]/.test(text)) text = `'${text}`; // não deixa o Excel interpretar como fórmula
  return /[";\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const toCsv = (rows) => rows.map((row) => row.map(csvCell).join(";")).join("\r\n");

export const csvBlob = (rows) => new Blob([`\uFEFF${toCsv(rows)}`], { type: "text/csv;charset=utf-8" });
